module.exports = __webpack_public_path__ + "img/contact.e9280179.svg";